import { Pipe, PipeTransform } from '@angular/core';

import { Address } from '../data/models/components/address';

@Pipe({
  name: 'addressToString',
})
export class AddressToStringPipe implements PipeTransform {
  transform(address: Address): string {
    if (!address || !address.street || !address.zipcode || !address.city) {
      return '';
    }
    return `${address.street}, ${address.zipcode} ${address.city}`;
  }
}
